export default function FeatureInDevelopmentRobot() {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#ffffff',
        overflow: 'hidden',
      }}
    >
      {/* Background Graphic Layer */}
      <img
        src="/feature-robot-bg-2.png"
        alt="Background Graphic"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'right center',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />

      {/* Foreground Content Layer */}
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '0 8%',
          maxWidth: '800px',
        }}
      >
        <h1
          style={{
            fontSize: 'clamp(28px, 4vw, 44px)',
            fontWeight: 900,
            color: '#0b5cd5',
            textTransform: 'uppercase',
            marginBottom: '24px',
            lineHeight: '1.3',
            letterSpacing: '0.5px',
          }}
        >
          Tính năng đang
          <br />
          phát triển
        </h1>

        <button
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            backgroundColor: '#0b5cd5',
            color: '#ffffff',
            border: 'none',
            borderRadius: '9999px',
            padding: '12px 28px',
            fontSize: '18px',
            fontWeight: 600,
            cursor: 'pointer',
            boxShadow: '0 4px 10px rgba(11, 92, 213, 0.3)',
            transition: 'all 0.2s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = '#0848a8'
            e.currentTarget.style.transform = 'translateY(-2px)'
          }}
          onFocus={(e) => {
            e.currentTarget.style.backgroundColor = '#0848a8'
            e.currentTarget.style.transform = 'translateY(-2px)'
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = '#0b5cd5'
            e.currentTarget.style.transform = 'translateY(0)'
          }}
          onBlur={(e) => {
            e.currentTarget.style.backgroundColor = '#0b5cd5'
            e.currentTarget.style.transform = 'translateY(0)'
          }}
          onClick={() => typeof window !== 'undefined' && window.history.back()}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M9 14L4 9l5-5" />
            <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11" />
          </svg>
          Quay lại
        </button>
      </div>
    </div>
  )
}
